import Cookies from 'js-cookie'

export const TOUCH_FIRST_COOKIE = 'mx_touch_first'
export const TOUCH_LAST_COOKIE = 'mx_touch_last'
export const RENSHU_CID_COOKIE = 'mx_renshu_cid'
export const KATALYS_TRANSACTION_ID_COOKIE = 'mx_katalys_transaction_id'
export const KATALYS_OFFER_ID_COOKIE = 'mx_katalys_offer_id'
export const KATALYS_PUBLISHER_ID_COOKIE = 'mx_katalys_publisher_id'
// Matches the app's consumeKatalysParams expiry.
export const KATALYS_EXPIRY_DAYS = 30

const COOKIE_EXPIRY_DAYS = 400
// Matches Renshu's own 30-day revenue attribution window.
const RENSHU_CID_EXPIRY_DAYS = 30
const MAX_VALUE_LENGTH = 200

const PARAM_KEYS = {
  utm_source: 'us',
  utm_medium: 'um',
  utm_campaign: 'uc',
  utm_content: 'un',
  utm_term: 'ut',
  gclid: 'g',
  fbclid: 'f',
  ttclid: 't',
  msclkid: 'm',
}

const referrerHostname = () => {
  try {
    if (!document.referrer) return ''
    return new URL(document.referrer).hostname
  } catch {
    return ''
  }
}

const buildPayload = () => {
  const params = new URLSearchParams(window.location.search)
  const payload = {}
  let hasParams = false

  Object.entries(PARAM_KEYS).forEach(([param, key]) => {
    const value = params.get(param)?.trim()
    if (value) {
      payload[key] = value.slice(0, MAX_VALUE_LENGTH)
      hasParams = true
    }
  })

  const referrer = referrerHostname()
  if (referrer) payload.r = referrer

  payload.lp = window.location.pathname
  payload.ts = Math.floor(Date.now() / 1000)

  return { payload, hasParams }
}

const writeCookie = (name, value, expires = COOKIE_EXPIRY_DAYS) => {
  try {
    Cookies.set(name, value, {
      expires,
      domain: '.maximustribe.com',
      secure: true,
      sameSite: 'Lax',
    })
  } catch {
    return
  }
}

// Renshu click id from a shoguntrk email link. Latest click wins, and Rails reads
// the cookie at registration to attribute the order server-side (MAX-12434).
const captureRenshuClickId = () => {
  const cid = new URLSearchParams(window.location.search).get('cid')?.trim()
  if (cid) {
    writeCookie(RENSHU_CID_COOKIE, cid.slice(0, MAX_VALUE_LENGTH), RENSHU_CID_EXPIRY_DAYS)
  }
}

const removeCookie = name => {
  try {
    Cookies.remove(name, { domain: '.maximustribe.com' })
  } catch {
    return
  }
}

// Katalys (RevOffers) affiliate click. Mirrors consumeKatalysParams in the app:
// a new transaction_id starts a new click, so offer/publisher cookies from an
// older click are removed when absent. The app reads these at registration
// (MAX-11687).
const captureKatalysClickId = () => {
  if (process.env.KATALYS_ENABLED !== '1') return

  const params = new URLSearchParams(window.location.search)
  const read = param => params.get(param)?.trim().slice(0, MAX_VALUE_LENGTH)

  const transactionId = read('transaction_id')
  if (!transactionId) return

  const writeOrRemove = (name, value) => (value ? writeCookie(name, value, KATALYS_EXPIRY_DAYS) : removeCookie(name))

  writeCookie(KATALYS_TRANSACTION_ID_COOKIE, transactionId, KATALYS_EXPIRY_DAYS)
  writeOrRemove(KATALYS_OFFER_ID_COOKIE, read('offer_id'))
  writeOrRemove(KATALYS_PUBLISHER_ID_COOKIE, read('publisher_id'))
}

export const captureAttributionCookies = () => {
  if (typeof window === 'undefined') return

  const { payload, hasParams } = buildPayload()
  const value = JSON.stringify(payload)

  if (!Cookies.get(TOUCH_FIRST_COOKIE)) {
    writeCookie(TOUCH_FIRST_COOKIE, value)
  }

  if (hasParams) {
    writeCookie(TOUCH_LAST_COOKIE, value)
  }

  captureRenshuClickId()
  captureKatalysClickId()
}
